import React, { useEffect, useRef, useState } from 'react';
import { Box, Input, Text } from '@chakra-ui/react';

export type HisScannerProps = {
  onScan: (data: string) => void;
  onConnectionChange?: (connected: boolean) => void;
};

export default function HIDScanner({ onScan, onConnectionChange }: HisScannerProps) {
  const [isConnected, setIsConnected] = useState(true);
  const inputRef = useRef<HTMLInputElement>(null);

  // Notify parent component that scanner is connected
  useEffect(() => {
    onConnectionChange?.(true);
    return () => {
      onConnectionChange?.(false);
    };
  }, [onConnectionChange]);

  // Focus the input field when component mounts
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // If Enter key is pressed, process the scanned code
    if (e.key === 'Enter') {
      const value = inputRef.current?.value.trim();
      if (value) {
        onScan(value);
        // Clear the input field after processing
        if (inputRef.current) {
          inputRef.current.value = '';
        }
      }
    }
  };

  const handleFocus = () => {
    setIsConnected(true);
    onConnectionChange?.(true);
  };

  const handleBlur = () => {
    setIsConnected(false);
    onConnectionChange?.(false);
  };

  return (
    <Box>
      <Text mb={2} color={isConnected ? 'green.500' : 'orange.500'} fontWeight="bold">
        {isConnected ? 'HIS Scanner Ready' : 'HIS Scanner - Click to Activate'}
      </Text>
      <Input
        ref={inputRef}
        placeholder="Scan barcode or type and press Enter"
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
        onBlur={handleBlur}
        autoFocus
        size="md"
        borderColor={isConnected ? 'green.300' : 'grey.300'}
        _focus={{
          borderColor: 'green.400',
          boxShadow: '0 0 0 1px var(--chakra-colors-green-400)',
        }}
      />
    </Box>
  );
}
